import { Component, Input } from '@angular/core';

@Component({
    selector: 'status-message',
    templateUrl: 'status-message.html'
})
export class StatusMessageComponent {

    @Input('type') type: string;
    @Input('text') text: any;

    useSpan: boolean = true;

    classes(): string {
        this.useSpan = true;
        if (this.type !== undefined) {
            switch (this.type) {
                case 'success':
                case 'warning':
                case 'danger':
                case 'pink':
                    return 'message ' + this.type;
                case 'white-on-pink':
                    this.useSpan = false;
                    return 'message left-align white-on-pink';
                case 'white-on-green':
                    this.useSpan = false;
                    return 'message left-align white-on-green';
                case 'review':
                    this.useSpan = false;
                    return 'message success left-align';
                case 'return':
                    this.useSpan = false;
                    return 'message success left-align return-icon';
            }
        }
        return 'hidden';
    }

    showIcon(icon: string): boolean {
        if (icon === 'success' && this.type === 'pink') return true;
        return icon === this.type;
    }

    get showText(): boolean {
        return this.text !== undefined;
    }

}



// WEBPACK FOOTER //
// ./src/components/status-message/status-message.ts